import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { getDeliveryRun } from '../services/delivery-runs.service';

/** Detail poll cadence (ms) while a run is still non-terminal. */
const DETAIL_POLL_MS = 4000;

interface Options {
  /** Set `false` while the SSE stream is live — frames update the cache, so polling would only add load. */
  poll?: boolean;
}

/**
 * Run detail — summary header + timing/signals/currentStage/lineage. Polls every
 * 4s while the run is non-terminal (the server overlays a live Temporal query),
 * then stops once `isTerminal` flips (the server-derived terminal flag — never
 * hardcode the terminal status set). Polling pauses while `poll` is `false`
 * (the live stream is connected) and resumes the moment it isn't.
 */
export function useDeliveryRunDetail(runId: string, enabled = true, { poll = true }: Options = {}) {
  return useQuery({
    queryKey: queryKeys.deliveries.run(runId),
    queryFn: () => getDeliveryRun(runId),
    enabled: !!runId && enabled,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data || !poll) return false;
      return data.isTerminal ? false : DETAIL_POLL_MS;
    },
  });
}
